export default "__VITE_ASSET__Bh$xMlkc__"